module.exports = __webpack_public_path__ + "img/iconUser.95b7c927.png";